import { DocumentEvents } from "./../helpers/document-events";
import { CategoryDocumentView } from "./category-document";
import { CaseDocumentView } from "./case-document";
import { LegislationDocumentView } from "./legislation-document";
import { GenericDocumentView } from "./generic-document";
import { IDocumentModel } from "./../interfaces/document-model";
import Marionette from "../../shared/marionette-mustache";
import {autoinject, Container, transient} from "aurelia-dependency-injection";
import {DocumentHolderModel} from "../../desktop/models/document-holder";
import {DocumentErrorView} from "../../desktop/views/document-error";
import {CaseDocumentModel} from "../../desktop/models/case-document";
import {SiblingModel} from "../../desktop/models/stage";
import {TemplateManager} from "../../shared/helpers/template-manager";
import {SizeManager} from "../../shared/helpers/size-manager";
import {TemplateModel} from "../../shared/helpers/template-model";
import {ThinkerView} from "../../shared/views/thinker";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import {AppEvents} from "../../app-events";
import {TRANSITION} from "../../desktop/views/desktop";
import {DeviceHelper} from "../../shared/helpers/device-helper";
import {MobileHelper} from "../../shared/helpers/mobile-helper";
import { EUDocumentView } from "./eu-document";
import { ViewMode, DocumentStateModel } from "../models/document-state";
import { JustisUrl } from "../../shared/helpers/justis-url";

const template = require<string>("../../desktop/views/document-holder.html");

const dom = {
    DOCUMENT_SHELL: ".document-shell",
    DOCUMENT_BODY: ".document-body",
    DOCUMENT: ".document",
    RESIZE_ICONS: ".resize-icons",
    CLOSER: ".document-closer",
    DOCUMENT_LINKS: ".document-link",
    STAGE_LINKS: ".stage-link",
    LOADING_REGION: ".document-loading",
    CONTENT_REGION: ".document-content",
    VIEW_SWITCHER: ".view-switcher",
    FACE: ".document-face",
    SIGN_IN_LINKS: ".sign-in-link",
    DOCUMENT_MASK: ".document-mask",
    CATEGORY_TREND: ".category-trend"
};

@backboneViewProperties({
    template,
    // className: "document-holder"
})
@autoinject
@transient()
export class DocumentHolderView extends Marionette.LayoutView<DocumentHolderModel> {

    private recoveryX: number;
    private recoveryY: number;
    private loadingRegion: Marionette.Region;
    private contentRegion: Marionette.Region;

    constructor(private appEvents: Backbone.Events, private templateManager: TemplateManager, private sizeManager: SizeManager) {
        super();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events[`click ${dom.RESIZE_ICONS}`] = this.resizeClick;
        events[`click ${dom.CLOSER}`] = this.closeButtonClick;
        events[`click ${dom.DOCUMENT_LINKS}`] = this.documentLinkClick;
        events[`click ${dom.STAGE_LINKS}`] = this.stageLinkClick;
        events[`click ${dom.DOCUMENT}`] = this.documentClick;
        events[`click ${dom.SIGN_IN_LINKS}`] = this.signinLinkClick;
        return events;
    }

    public onRender() {
        $(".document-mask", this.el).attr("data-document-ids", this.model.InitialStageId); // find the document mask and assign it its ID
        this.setupModelListeners();
    }

    public regions(): any {
        const regions: any = {
            loadingRegion : dom.LOADING_REGION,
            contentRegion : dom.CONTENT_REGION
        };
        return regions;
    }

    public setInitialSize() {
        this.$(dom.DOCUMENT).height(this.sizeManager.calculateHeight());

        const compact = this.model.Compact;
        this.$(dom.DOCUMENT).toggleClass("compact", compact);
        if (compact) {
            this.$(dom.VIEW_SWITCHER).fadeIn().css("display", "inline-block");
            this.$(dom.DOCUMENT_SHELL).width(this.sizeManager.DesktopSlotSize - 10);
            this.$(dom.DOCUMENT).width(this.sizeManager.DesktopSlotSize - 10);
        }
        this.setPosition(TRANSITION.INSTANT);
    }

    public enforcePrecedentMap() {
        const holder = this.$(dom.DOCUMENT_SHELL);
        const doc = this.$(dom.DOCUMENT);
        this.disableAnimation().then(() => {
            doc.addClass("instant");
            _.defer(() => {
                const previewSize = Math.min(doc.innerWidth(), doc.innerHeight());
                const marginLeft = (doc.innerWidth() / 2) - (previewSize / 2);
                const marginTop = (doc.innerHeight() / 2) - (previewSize / 2);
                this.$(".precedent-map-preview").css({ width: previewSize, height: previewSize, marginLeft, marginTop, display: "block" });
                const scale = (window.innerHeight * 0.6) / previewSize;
                const currentPos = this.getTransform(holder.get(0));
                this.recoveryX = currentPos.x;
                this.recoveryY = currentPos.y;
                const xpos = ((((window.innerWidth / 2) - (currentPos.x + 75)) - ((previewSize / 2) + marginLeft)) * scale) - 9 + "px";
                const ypos = ((((window.innerHeight / 2) - (currentPos.y + 40)) - ((previewSize / 2) + marginTop)) * scale) - 15 + "px";
                this.$(dom.DOCUMENT_SHELL).addClass("precedent-map-prep");
                this.transform(xpos, ypos, scale);
                _.defer(() => {
                    this.enableAnimation().then(() => {
                        doc.removeClass("instant");
                        this.exitPrecedentMap();
                    });
                });
            });
        });
    }

    public setSlot() {
        const mySlot = this.model.Slot;
        const visible = this.model.Visible;
        let pos = "0px";
        if (typeof (mySlot) !== "undefined") {
            pos = Math.round((this.sizeManager.DesktopSlotSize) * (mySlot - 1)) + "px";
        }
        if (visible) {
            this.transform(pos, "0px");
        }
    }

    public render() {
        this.$el.hide();
        Marionette.ItemView.prototype.render.call(this);
        this.setInitialSize();
        this.renderLoading();
        this.$el.fadeIn();
        return this;
    }

    public setPosition(transition: TRANSITION): void {
        if (transition === TRANSITION.INSTANT) {
            this.disableAnimation().then(() => {
               this.setSlot();
            });
        } else {
            this.enableAnimation().then(() => {
               this.setSlot();
            });
        }
        this.setVisibility();
    }

    private setVisibility(): void {
        const visible = this.model.Visible;
        if (!visible) {
            this.$el.hide();
        } else {
            this.setWindowTitle();
            this.$el.show();
        }
    }

    private setWindowTitle() {
        let title;
        if (this.model && this.model.TargetModel && this.model.TargetModel.Title) {
            title = `${this.model.TargetModel.Title} on JustisOne`;
        } else {
            title = "JustisOne";
        }
        if (document.title !== title) {
            document.title = title;
        }
    }

    private setupModelListeners() {
        this.listenTo(this.model.Documents, "add", this.onDocumentAdded);
        this.listenTo(this.model, "change:Target", this.targetDocumentChanged);
        this.listenTo(this.model, "SlotChange", this.setPosition);
        this.listenTo(this.model, "change:Removed", this.vanish);
        this.listenTo(this.model, "change:Layer", this.setLayer);
        this.listenTo(this.model, "change:Visible", this.setVisibility);
        this.listenTo(this.model, "change:Compact", this.compactChanged);
        this.listenTo(this.model, "change:PrecedentMap", this.precedentMapChange);
        this.listenTo(this.model, "change:StackPosition", this.setStackPosition);
        this.listenTo(this.model, "viewModeChanged", this.targetViewModeChanged);
        this.appEvents.on(AppEvents.WindowResized, () => { this.setInitialSize(); });
    }

    private onDocumentAdded() {
        let concatenatedIds = "";
        this.model.Documents.each((doc) => concatenatedIds = concatenatedIds + " " + doc.Id);

        $(dom.DOCUMENT_MASK).filter("[data-document-ids*=" + this.model.InitialStageId + "]").attr("data-document-ids", concatenatedIds );
        // append the URL to the data-document-ids attribute, so it has the Ids of all documents in this holder
    }

    private setStackPosition(model, prop) {
        const holder = this.$(dom.DOCUMENT_SHELL);
        const z = (prop * 50) + 50;
        holder.css({ visibility: "visible", zIndex: z });
        this.transform("0px", (prop * 50) + "px");
    }

    private async targetDocumentChanged() {
        // At this point we may have been given a new model with just an Id, not populated
        const targetModel = this.model.TargetModel;
        if (targetModel) {
            this.renderLoading();
            try {
                const documentModel = await targetModel.load();
                try {
                    const documentTemplate = await this.templateManager.getTemplate("generic", documentModel.DocumentAccessSku);
                    this.model.Siblings = targetModel.Siblings || new Backbone.Collection<SiblingModel>();
                    this.renderDocument(documentTemplate, targetModel);
                    this.loadingRegion.reset();
                    this.appEvents.trigger(AppEvents.DocumentLoaded, documentModel);

                    _.delay(() => {
                        const url = this.getActiveUrl(targetModel);
                        Backbone.history.navigate(url, {trigger: false});
                    }, 1000);
                } catch (error) {
                    this.renderError(error);
                }
            } catch (err) {
                this.renderError(err);
            }
        }
    }

    private renderLoading(): void {
        const thinker = new ThinkerView();
        if (this.contentRegion !== undefined) {
            this.contentRegion.reset();
        }
        if (this.loadingRegion !== undefined) {
            this.loadingRegion.show(thinker);
        }
    }

    private renderDocument(templ: TemplateModel, model: IDocumentModel): void {
        const documentView = this.createViewOfCorrectType(model, templ);
        if (this.loadingRegion === undefined) { return; }
        if (this.contentRegion !== undefined) {
            this.setInitialSize();
            this.contentRegion.show(documentView);
            this.setInitialSize();
        }
        this.loadingRegion.reset();
    }

    private renderError(errorMessage): void {

        const errorModel = Container.instance.get(CaseDocumentModel);
        if (errorMessage) {
            errorModel.ErrorMessage = errorMessage;
        } else {
            errorModel.ErrorMessage = "An unknown error occurred";
        }

        const errorView = new DocumentErrorView({ model: errorModel });

        if (this.loadingRegion === undefined) { return; }

        if (this.contentRegion !== undefined) {
            this.contentRegion.show(errorView);
        }

        this.loadingRegion.reset();
    }

    private createViewOfCorrectType(model: IDocumentModel, templ: TemplateModel): Marionette.ItemView<Backbone.Model> {
        if (model.Error) {
            return new DocumentErrorView({ model });
        }
        let docView: GenericDocumentView;
        switch (model.RenderType.toLowerCase()) {
            case "case":
                docView = new CaseDocumentView({model: model, template: templ.Raw});
                break;
            case "statute":
            case "si":
            case "statutesection":
            case "statute_section":
            case "statutepreamble":
            case "statuteschedule":
            case "primarylegislation":
            case "secondarylegislation":
                docView = new LegislationDocumentView({model: model, template: templ.Raw});
                break;
            case "category":
                docView = new CategoryDocumentView({model: model, template: templ.Raw});
                break;
            default:
                if (model.RenderType.toLowerCase().startsWith("eu_sector")) {
                    docView = new EUDocumentView({model: model, template: templ.Raw});
                }
                else {
                    docView = new GenericDocumentView({model: model, template: templ.Raw});
                }
        }
        return docView;
    }

    /** Reacts to the close button of a DocumentHolder being clicked */
    private closeButtonClick(e: JQueryEventObject): void {
        e.stopPropagation();
        this.appEvents.trigger(AppEvents.ClearCIC, {docKey: this.model.InitialStageId});
        this.appEvents.trigger(AppEvents.DocumentHolderClosed, this.model);
    }

    private documentClick(): void {
        this.focusMe(this.model.InitialStageId);
    }

    // This id is a document holder id.
    private focusMe(id): void {
        if (id !== this.model.InitialStageId) {
            return;
        }
        // It's me!
        const targetModel = this.model.TargetModel;

        // Return if targetModel is undefined.  Need to look into why we get to here if model and view
        // are supposed to me removed so just a temp fix
        if (!targetModel) {
            return;
        }

        let url: string;
        if (targetModel.Error) {
            url = `case/error/overview/${targetModel.Id}`;
        } else {
            url = this.getActiveUrl(targetModel);
        }
        Backbone.history.navigate(url, {trigger: false});
    }

    private getActiveUrl(targetModel: IDocumentModel) {
        const activeTab = targetModel.uistate.ActiveTab;
        const currentTabId = activeTab && activeTab.Identifier ? activeTab.Identifier : "overview";
        return targetModel.Url.replace("overview", currentTabId);
    }

    private vanish(): void {
        if (this.model.Removed) {
            this.$(dom.DOCUMENT_SHELL).addClass("vanish");
            this.model.unset("Slot");
            this.contentRegion.empty();
        }
    }

    private resizeClick(): void {
        this.model.toggleCompact();
    }

    private compactChanged(): void {
        const compact = this.model.Compact;
        this.model.Documents.each((d) => {
            d.trigger(DocumentEvents.CompactChanged); // let each document know
        });
        this.$(dom.DOCUMENT).height(this.sizeManager.calculateHeight());
        if (compact) {
            this.contract();
        } else {
            this.expand();
        }
    }

    private disableAnimation(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.$(dom.DOCUMENT_SHELL).removeClass("animated");
            _.defer(() => {
                resolve();
            });
        });
    }

    private disableDocumentAnimation(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.$(dom.FACE).removeClass("animated");
            this.$(dom.DOCUMENT).removeClass("animated");
            _.defer(() => {
                resolve();
            });
        });
    }

    private enableAnimation(): Promise<any>  {
         return new Promise((resolve, reject) => {
            this.$(dom.DOCUMENT_SHELL).addClass("animated");
            _.defer(() => {
                resolve();
            });
        });
    }

    private enableDocumentAnimation(): Promise<any>  {
         return new Promise((resolve, reject) => {
            this.$(dom.FACE).addClass("animated");
            this.$(dom.DOCUMENT).addClass("animated");
            _.defer(() => {
                resolve();
            });
        });
    }

    private contract() {
        this.disableDocumentAnimation().then(() => {
            const fullWidth = this.sizeManager.DesktopSlotSize;
            this.$(dom.DOCUMENT_SHELL).width(fullWidth - 10);
            this.$(dom.DOCUMENT).width(fullWidth - 10);

            this.$(dom.VIEW_SWITCHER).fadeIn().css("display", "inline-block");
            this.$(dom.DOCUMENT).addClass("compact");
            _.delay(() => {
                this.enableDocumentAnimation();
                this.markHiddenDocumentFaceAsAriaHidden();
            }, 200);
        });
    }

    private expand() {
        this.disableDocumentAnimation().then(() => {
            this.$(dom.DOCUMENT).removeClass("compact");
            this.$(dom.VIEW_SWITCHER).hide();
            this.$(dom.DOCUMENT_SHELL).width("inherit");
            this.$(dom.DOCUMENT).width("inherit");
            _.defer(() => {
                this.enableDocumentAnimation();
                this.markHiddenDocumentFaceAsAriaHidden();
            });
        });
    }

    private markHiddenDocumentFaceAsAriaHidden() {
        if (this.$(dom.DOCUMENT).hasClass("compact")) {
            const isFlipped = this.$(dom.DOCUMENT_BODY).hasClass("flip");
            this.$(dom.DOCUMENT_BODY).find(".document-face.analysis").attr("aria-hidden", isFlipped.toString());
            this.$(dom.DOCUMENT_BODY).find(".document-face.full-text").attr("aria-hidden", (!isFlipped).toString());
        } else {
            this.$(".document-face").attr("aria-hidden", false.toString());
        }
    }

    private setLayer(): void {
        this.$(dom.DOCUMENT_SHELL).css("zIndex", this.model.Layer * 100);
    }

    private transform(x: string, y: string, scale?: number): void {
        const transform = `translate(${x},${y})` + (scale ? ` scale(${scale})` : "");
        this.$(dom.DOCUMENT_SHELL).css({
            webkitTransform: transform,
            MozTransform: transform,
            OTransform: transform,
            msTransform: transform,
            transform
        });
    }

    private enterPrecedentMap() {
        const holder = this.$(dom.DOCUMENT_SHELL);
        const doc = this.$(dom.DOCUMENT);
        this.enableAnimation().then(() => {
            this.removeTransitionEndListeners();
            const previewSize = Math.min(doc.innerWidth(), doc.innerHeight());
            const marginLeft = (doc.innerWidth() / 2) - (previewSize / 2);
            const marginTop = (doc.innerHeight() / 2) - (previewSize / 2);
            this.$(".precedent-map-preview").css({ width: previewSize, height: previewSize, marginLeft, marginTop, display: "block" });

            const scale = (window.innerHeight * 0.56) / previewSize;
            const currentPos = this.getTransform(holder.get(0));
            this.recoveryX = currentPos.x;
            this.recoveryY = currentPos.y;
            const xpos = ((((window.innerWidth / 2) - (currentPos.x + 75)) - ((previewSize / 2) + marginLeft)) * scale) - 25 + "px";
            const ypos = ((((window.innerHeight / 2) - (currentPos.y + 40)) - ((previewSize / 2) + marginTop)) * scale) - 10 + "px";
            _.defer(() => {
                this.$(dom.DOCUMENT_SHELL).addClass("precedent-map-prep");
                const transitionEvent = this.whichTransitionEvent();
                this.$(dom.DOCUMENT_SHELL).on(transitionEvent, () => {
                    this.removeTransitionEndListeners();
                    this.appEvents.trigger(AppEvents.DocumentReadyForPrecedentMap);
                    this.disappearForPrecedentMap();
                });
                this.transform(xpos, ypos, scale);
            });
        });
    }

    private disappearForPrecedentMap() {
        this.$(dom.DOCUMENT_SHELL).addClass("precedent-map-engaged");
    }

    private exitPrecedentMap() {
        const holder = this.$(dom.DOCUMENT_SHELL);
        _.defer(() => {
            _.delay(() => {
                _.delay(() => {
                    this.removeTransitionEndListeners();
                    holder.removeClass("precedent-map-exit");
                    this.$(".precedent-map-preview").removeClass("precedent-map-exit").hide();
                }, 410);
                holder.removeClass("precedent-map-prep").addClass("precedent-map-exit");
                this.transform(this.recoveryX + "px", this.recoveryY + "px", 1);
            }, 410);
            holder.removeClass("precedent-map-engaged");
            this.$(".precedent-map-preview").addClass("precedent-map-exit");
        });
    }

    private removeTransitionEndListeners() {
        const transitionEvent = this.whichTransitionEvent();
        this.$(dom.DOCUMENT_SHELL).off(transitionEvent);
    }

    private makeWayForOtherPrecedentMap() {
        const holder = this.$(dom.DOCUMENT_SHELL);
        holder.addClass("pmap-avoid");
    }

    private resumeFromAvoid() {
        const holder = this.$(dom.DOCUMENT_SHELL);
        holder.removeClass("pmap-avoid");
    }

    private precedentMapChange(model, prop) {
        switch (prop) {
            case "active":
                this.enterPrecedentMap();
                break;
            case "exit":
                if (model.previous("PrecedentMap") === "active") {
                    this.exitPrecedentMap();
                } else {
                    this.resumeFromAvoid();
                }
                break;
            case "avoid":
                this.makeWayForOtherPrecedentMap();
                break;
            default:
                break;
        }
    }

    private documentLinkClick(e: JQueryEventObject) {
        if (e.ctrlKey) { return true; }

        if (!$(e.currentTarget).parents(".statute-outline-list").length) {
            const id = $(e.currentTarget).attr("data-document-id");
            const id2 = $(e.currentTarget).attr("data-id"); // The in-document links only have the data-id property, not data-document-id
            this.flashOtherDocument(id);
            this.flashOtherDocument(id2);
        }

        this.documentClick();
        const targetDocUrl = new JustisUrl($(e.currentTarget).attr("href"));

        this.appEvents.trigger(AppEvents.AppInsightsDocumentMetaGotoLink, { Url: targetDocUrl.url});
        e.preventDefault();
        Backbone.history.navigate(targetDocUrl.url, true);
        e.preventDefault();
        return false;
    }

    /**
     * Finds the DOM element which contains the document with id docId and causes it to flash.
     */
    private flashOtherDocument(docId: string): void {
        // This should really be the reponsibility of the document holder which contains the document, not the document holder on which a link was clicked
        // However due documentLinkClick() using Backbone.History.Navigate there's no way to pass on the information relating to which doc needs flashing
        // For this reason we've done it here, even though it goes somewhat against OO principles.
        if (this.model.Compact) {
            $(dom.DOCUMENT_MASK).filter("[data-document-ids*=" + docId + "]").addClass("flash");
            setTimeout(() => { $(dom.DOCUMENT_MASK).removeClass("flash"); }, 500);
        }
    }

    /** Reacts to a stage in the dropdown on a DocumentHolder being clicked */
    private stageLinkClick(e: JQueryEventObject): boolean {
        e.stopPropagation();
        e.preventDefault();
        if (e.ctrlKey) { return true; }
        const $clicked = $(e.currentTarget);
        if ($clicked.parent().hasClass("active")) { return false; }
        const targetDocUrl = $clicked.attr("href");
        this.appEvents.trigger(AppEvents.AppInsightsDocumentStageSelected, { StageName: $(e.currentTarget).text(), Url: targetDocUrl});
        Backbone.history.navigate(targetDocUrl, {trigger: true});
        return false;
    }

    private getTransform(el): any {
        const obj = $(el);
        const transformMatrix = obj.css("-webkit-transform") ||
            obj.css("-moz-transform") ||
            obj.css("-ms-transform") ||
            obj.css("-o-transform") ||
            obj.css("transform");
        const matrix = transformMatrix.replace(/[^0-9\-.,]/g, "").split(",");
        const pos: any = {};
        pos.x = matrix[12] || matrix[4];
        pos.y = matrix[13] || matrix[5];
        return pos;
    }

    private whichTransitionEvent(): string {
        const el = document.createElement("fakeelement");
        const transitions = {
            transition: "transitionend",
            OTransition: "oTransitionEnd",
            MozTransition: "transitionend",
            WebkitTransition: "webkitTransitionEnd"
        };

        for (const t in transitions) {
            if (transitions.hasOwnProperty(t)) {
                if (el.style[t] !== undefined) {
                    return transitions[t];
                }
            }
        }
    }

    private signinLinkClick(e: JQueryEventObject): void {
        e.preventDefault();
        e.stopPropagation();
        const returnUrl = window.location.pathname;
        const signinUrl = `signin?return=${returnUrl}`;
        Backbone.history.navigate(signinUrl, { trigger: true });
    }

    private targetViewModeChanged(mode: string): void {
        this.markHiddenDocumentFaceAsAriaHidden();
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/document-holder.ts